export const ADMIN = 'ADMIN';
export const NOROLE = 'NONE';
export const SEEDPRODUCER = 'SEEDPRODUCER';
export const FARMER = 'FARMER';
export const PROCESSOR = 'PROCESSOR';
export const REGULATOR = 'REGULATOR';
